import React, { useCallback } from "react";
import {
    ButtonWrapper,
    LoadingWrapper,
} from './RoundedButton.styled';
import CircularProgress from "@mui/material/CircularProgress";

const RoundedButton = ({
    type = 'button',
    width,
    height,
    kind = 'primary',
    outline = false,
    children,
    margin,
    icon,
    disabled = false,
    fontSize,
    fontWeight,
    onClick,
    borderRadius,
    className,
    color,
    dataTestId,
    loading = false,
    loadingProgressProps = {}
}) => {
    const handleClick = useCallback((e) => {
        onClick && onClick(e);
    }, [onClick]);

    return (
        <ButtonWrapper
            type={type}
            data-testid={dataTestId}
            disabled={disabled}
            height={height}
            width={width}
            kind={kind}
            $outline={outline}
            margin={margin}
            fontSize={fontSize}
            fontWeight={fontWeight}
            onClick={handleClick}
            $borderRadius={borderRadius}
            className={className}
            color={color}
        >
            {icon && icon.position === 'left' && icon.element}
            {children}
            {icon && icon.position === 'right' && icon.element}
            {loading && (
              <LoadingWrapper data-testid="loading-indicator">
                  <CircularProgress
                    role="progressbar"
                    {...loadingProgressProps}
                  />
              </LoadingWrapper>
            )}
        </ButtonWrapper>
    );
};

export default RoundedButton;
